import {
  APP_INIT,
  TOKENS_LOCAL_LOADED,
  CUSTOM_TOKEN_ADDED,
  TOKEN_ADDRESS_CHANGE,
  TOKEN_BALANCE_UPDATE,
  TOKEN_ALLOWANCE_UPDATE,
  TOKEN_INFO_UPDATE,
  PAYMENT_SEND_SUBMITTED,
} from '../actionTypes';

export const getDefaultState = () => ({
  address: '',
  balance: null,
  allowance: null,
  localTokenList: {},
  defaultTokenList: {},
  customTokenAddress: '',
});

const reducer = (state = getDefaultState(), action) => {
  switch (action.type) {
    case APP_INIT:
      return {
        ...state,
        defaultTokenList: {
          ...action.defaultTokenList,
        },
      };

    case TOKENS_LOCAL_LOADED:
      return {
        ...state,
        localTokenList: {
          ...state.localTokenList,
          ...action.localTokenList,
        },
      };

    case CUSTOM_TOKEN_ADDED:
      return {
        ...state,
        localTokenList: {
          ...state.localTokenList,
          [action.address]: {
            name: action.name,
            symbol: action.symbol,
            decimals: action.decimals,
            address: action.address,
            isCustom: true,
          },
        },
      };

    case TOKEN_ADDRESS_CHANGE:
      return {
        ...state,
        address: action.address,
        // Clear allowance/balance when address changes.
        allowance: action.address !== state.address ? null : state.allowance,
        balance: action.address !== state.address ? null : state.balance,
      };

    case TOKEN_BALANCE_UPDATE:
      return {
        ...state,
        balance: action.balance,
      };

    case TOKEN_ALLOWANCE_UPDATE:
      return {
        ...state,
        allowance: action.allowance,
      };

    case TOKEN_INFO_UPDATE:
      return {
        ...state,
        localTokenList: {
          ...state.localTokenList,
          ...action.tokens.reduce(
            (tokens, token) => ({ ...tokens, [token.address]: { ...token } }),
            {},
          ),
        },
      };

    case PAYMENT_SEND_SUBMITTED:
      return {
        ...state,
        address: '',
        balance: null,
        allowance: null,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/token.js